export default __webpack_public_path__ + "static/media/pawn_bishop_bg.83f0c120.png";